import { render, staticRenderFns } from "./DebtSummary.vue?vue&type=template&id=214a5ae9"
import script from "./DebtSummary.vue?vue&type=script&lang=js"
export * from "./DebtSummary.vue?vue&type=script&lang=js"
import style0 from "./DebtSummary.vue?vue&type=style&index=0&id=214a5ae9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DebtSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports